import { AdapterInterface } from '../../types/global';
import { CampaignTemplatePresignedUrlRequest } from '../../api-models/types.gen';
import BaseAdapter from './baseAdapter';
import { CampaignTemplatePresignedUrlResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { UploadTemplatePresignedUrl } from '../../types/campaigns.type';

export default class PostUploadCampaignTemplatePresignedUrl extends BaseAdapter<CampaignTemplatePresignedUrlResponse> implements AdapterInterface {
  rawResponse: CampaignTemplatePresignedUrlResponse;

  modifiedRequest: CampaignTemplatePresignedUrlRequest;

  async adaptResponse(request: { benefitName: string, fileName: string }): Promise<UploadTemplatePresignedUrl> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/upload-campaign-template-presigned-url', HTTPMethod.Post, formattedRequest);
    return {
      putPresignedUrl: this.rawResponse.put_presigned_url,
      templateS3Key: this.rawResponse.s3_key,
    };
  }

  adaptRequest(request: { benefitName: string, fileName: string }): CampaignTemplatePresignedUrlRequest {
    this.modifiedRequest = {
      benefit_name: request.benefitName,
      file_name: request.fileName,
    };
    return this.modifiedRequest;
  }
}
